import styled from 'astroturf/react'
import PropTypes from 'prop-types'
import { BrandLogo } from '@calendly/ui/components/brand-logo'
import _Outer from "round_icon-Outer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/round_icon.js?styleId=Outer";
import _Logo from "round_icon-Logo.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/round_icon.js?styleId=Logo";

const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'

const Outer = /*#__PURE__*/styled('div', null, {
  displayName: "Outer",
  styles: _Outer
})

const Logo = /*#__PURE__*/styled(BrandLogo, null, {
  displayName: "Logo",
  styles: _Logo
})

const RoundIcon = ({ name, size = 'standard', className, ...rest }) => (
  <Outer
    className={[className, `size-${size}`].filter(Boolean).join(' ')}
    {...rest}
  >
    <Logo name={name} alt="" />
  </Outer>
)

RoundIcon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['xsmall', 'small', 'standard', 'large', 'xlarge']),
}

export default RoundIcon
